const protocol = import.meta.env.REACT_APP_PROTOCOL;
const host = import.meta.env.REACT_APP_HOST;
const port = import.meta.env.REACT_APP_STRAPI_PORT;
const folder = import.meta.env.REACT_APP_STRAPI_FOLDER;
let baseURL = `${protocol}://${host}`;
if (protocol === 'http' && port) {
  baseURL += `:${port}`;
}
if (folder) {
  baseURL += `/${folder}`;
}

const config = {
  http: {
    HOST: import.meta.env.REACT_APP_HOST,
    STRAPI_PORT: import.meta.env.REACT_APP_STRAPI_PORT,
    GOOGLE_EXPORT_PORT: import.meta.env.REACT_APP_GOOGLE_EXPORT_PORT,
    BASE_EXPORT_URL: import.meta.env.REACT_APP_BASE_EXPORT_URL,
    BASE_URL: baseURL,
  },
  auth: {
    GOOGLE_CLIENT_ID: import.meta.env.REACT_APP_GOOGLE_CLIENT_ID,
  },
  TECH_SKILLS_TABS: {
    developmentTechnologies: import.meta.env.REACT_APP_DEVELOPMENT_TECHNOLOGIES,
    ideOrTools: import.meta.env.REACT_APP_IDE_TOOLS,
    programmingLanguages: import.meta.env.REACT_APP_PROGRAMMING_LANGUAGES,
    versionControlSystems: import.meta.env.REACT_APP_VERSION_CONTROL_SYSTEM,
    dataBases: import.meta.env.REACT_APP_DATABASES,
    ciCdTools: import.meta.env.REACT_APP_CI_CD_TOOLS,
    iOsTechnologies: import.meta.env.REACT_APP_IOS_TECHNOLOGIES,
    androidTechnologies: import.meta.env.REACT_APP_ANDROID_TECHNOLOGIES,
    developmentMethodologies: import.meta.env.REACT_APP_DEVELOPMENT_METHODOLOGIES,
  },
  manager: {
    id: import.meta.env.REACT_APP_ROLE_ID,
  },
  teamManager: {
    id: import.meta.env.REACT_APP_TEAM_MANAGER_ROLE_ID,
  },
  saleRole: {
    id: import.meta.env.REACT_APP_SALE_ROLE_ID,
  },
};

export default config;
